
export * from './data/index';
// Re-export calendar specifically if not in index yet, or add to index. 
// Adding here for safety if index is not updated in same batch (it is below).
import { db, functions } from '../lib/firebase';
import { CalendarSettings, SaaSLandingContent, DEFAULT_SAAS_CONTENT } from '../types';

export const getCalendarSettings = async (): Promise<CalendarSettings> => {
    try {
        const snap = await db.collection('settings').doc('calendar').get();
        if (snap.exists) return snap.data() as CalendarSettings;
    } catch(e) {}
    // DEFAULT TO FALSE: Feature is optional and plan-gated. Must be enabled manually.
    return { enabled: false, phase: 'PHASE_1' };
};

export const updateCalendarSettings = async (settings: CalendarSettings) => {
    await db.collection('settings').doc('calendar').set(settings);
};

export const getGoogleAuthUrl = async () => {
    const fn = functions.httpsCallable('getGoogleAuthUrl');
    // Send current origin for dynamic redirection logic (supports custom domains & localhost)
    const res = await fn({ returnUrl: window.location.origin + '/google-callback' });
    return res.data as { url: string };
};

export const linkGoogleCalendar = async (code: string) => {
    const fn = functions.httpsCallable('linkGoogleCalendar');
    // Must match the redirect_uri used in step 1 exactly
    const res = await fn({ 
        code,
        returnUrl: window.location.origin + '/google-callback'
    });
    return res.data as { success: boolean, email: string };
};

export const listGoogleCalendars = async () => {
    const fn = functions.httpsCallable('listGoogleCalendars');
    const res = await fn();
    return res.data as { id: string, summary: string, primary: boolean }[];
};

export const retryCalendarSync = async (bookingId: string) => {
    const fn = functions.httpsCallable('retryCalendarSync');
    await fn({ bookingId });
};

export const fetchGoogleEvents = async (timeMin: string, timeMax: string) => {
    const fn = functions.httpsCallable('fetchGoogleEvents');
    const res = await fn({ timeMin, timeMax });
    return res.data as { events: any[] };
};

// --- SAAS LANDING PAGE CONTENT ---

export const getSaaSLandingContent = async (): Promise<SaaSLandingContent> => {
    try {
        const snap = await db.collection('settings').doc('saas_landing').get();
        if (snap.exists) {
            // Merge with defaults to ensure structure validity
            return { ...DEFAULT_SAAS_CONTENT, ...snap.data() } as SaaSLandingContent;
        }
    } catch (e) {
        console.warn("Failed to load SaaS content", e);
    }
    return DEFAULT_SAAS_CONTENT;
};

export const updateSaaSLandingContent = async (content: SaaSLandingContent) => {
    await db.collection('settings').doc('saas_landing').set(content);
};
